export const DataSecuritySection = () => (
  <section>
    <h2>8. Data Security</h2>

    <p>
      We and our hosting services implement systems, applications and procedures
      to secure your personal data, to minimize the risks of theft, damage, loss
      of information, or unauthorized access or use of information.
    </p>

    <p>
      These measures provide sound industry standard security. However, although
      we make efforts to protect your privacy, we cannot guarantee that our
      Sites, Platform or Services will be immune from any wrongdoings,
      malfunctions, unlawful interceptions or access, or other kinds of abuse
      and misuse.
    </p>
  </section>
);
